var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGnbDiscountOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "local_offer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6102 11.58L12.6102 2.58C12.2502 2.22 11.7502 2 11.2002 2H4.2002C3.1002 2 2.2002 2.9 2.2002 4V11C2.2002 11.55 2.4202 12.05 2.7902 12.42L11.7902 21.42C12.1502 21.78 12.6502 22 13.2002 22C13.7502 22 14.2502 21.78 14.6102 21.41L21.6102 14.41C21.9802 14.05 22.2002 13.55 22.2002 13C22.2002 12.45 21.9702 11.94 21.6102 11.58ZM13.2002 20.01L4.2002 11V4H11.2002V3.99L20.2002 12.99L13.2002 20.01Z",
    fill: "#00BF9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7002 8C7.52862 8 8.2002 7.32843 8.2002 6.5C8.2002 5.67157 7.52862 5 6.7002 5C5.87177 5 5.2002 5.67157 5.2002 6.5C5.2002 7.32843 5.87177 8 6.7002 8Z",
    fill: "#00BF9D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbDiscountOn);
export default __webpack_public_path__ + "static/media/gnb_discount_on.c78210ee7abb3c634844d16e6a75a7e1.svg";
export { ForwardRef as ReactComponent };